import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useIntl } from "react-intl";

import Snackbar from "@material-ui/core/Snackbar";
import { alertShown } from "../../redux/alert/alertActions";
import SnackbarContentWrapper from "./snackbarContentWrapper";

export const Alerts = (props) => {
    const { alerts } = props;
    const [open, setOpen] = useState(false);
    const [messageInfo, setMessageInfo] = useState(null);
    const intl = useIntl();

    // Add new alerts to the queue
    useEffect(() => {
        processQueue();
    }, [alerts]);

    const processQueue = () => {
        if (alerts.length > 0) {
            // get first alert in the queue
            const msgInfo = alerts[0];
            if (msgInfo.msgParams && msgInfo.msgParams.actionDesc && msgInfo.isObj) {
                msgInfo.msgParams.actionDesc = intl.formatMessage(msgInfo.msgParams.actionDesc);
            }
            setOpen(true);
            setMessageInfo(msgInfo);

            // update the app alerts state
            props.alertShown(msgInfo.key);
        }
    };

    const handleClose = (e, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const handleExited = () => {
        processQueue();
    };

    return (
        <div>
            {messageInfo && (
                <Snackbar
                    key={messageInfo.key}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    open={open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    onExited={handleExited}
                    ContentProps={{
                        "aria-describedby": "message-id",
                    }}>
                    <SnackbarContentWrapper
                        onClose={() => handleClose(null, null)}
                        variant={messageInfo.type}
                        message={
                            messageInfo.message &&
                            messageInfo.message.id == "alerts.follow-ups-sagas.save-failed" &&
                            messageInfo.msgParams &&
                            messageInfo.msgParams.body
                                ? messageInfo.msgParams.body.errorMessages
                                : intl.formatMessage(messageInfo.message, messageInfo.msgParams)
                        }
                    />
                </Snackbar>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        alerts: state.alerts,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            alertShown,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
